import { SUBSCRIPTION_INTERVAL, SUBSCRIPTION_STATUS } from "shared/enums/common.enum";
import { Company } from "../companies/company";
import { SubscriptionPrice } from "./subscription-price";

export class Subscription {
    id!: string;
    name!: string;
    
    //additional fields started
    price!: number;
    yearlyPrice!: number;
    //additional fields ended
    
    maxUsers: number = 0;
    maxWarehouses: number = 0;
    maxServiceTrucks: number = 0;
    status!: SUBSCRIPTION_STATUS;
    createdAt!: string;
    updatedAt!: string;
    subscriptionPlanCompanies: SubscriptionPlanCompany[] = [];
    hasTrial!: boolean;
    stripePriceId!: string;
    isGlobal!: boolean;
    interval!: string;
    isLocked!: boolean;
    trialDays!: number;
    isArchived!: boolean;
    subscriberCompanyCount!: number;
    assignedCompanyCount!: number;
    subscriptionPrices: SubscriptionPrice[] = [];
    features: string[] = [];
    description!: string;
    
    constructor(data?: Partial<Subscription>) {
        Object.assign(this, data);
        if (data?.maxUsers) this.maxUsers = +data.maxUsers;
        if (data?.maxWarehouses) this.maxWarehouses = +data.maxWarehouses;
        if (data?.maxServiceTrucks) this.maxServiceTrucks = +data.maxServiceTrucks;
        if (data?.price) this.price = +data.price;
        if(data?.subscriptionPrices) {
            this.subscriptionPrices = data.subscriptionPrices.map(i => new SubscriptionPrice(i));
            this.price = this.subscriptionPrices.find(i => i.interval === SUBSCRIPTION_INTERVAL.MONTH)?.price || 0;
            this.yearlyPrice = this.subscriptionPrices.find(i => i.interval === SUBSCRIPTION_INTERVAL.YEAR)?.price || 0;
        }
    }
}

class SubscriptionPlanCompany{
    companyId!: string;
    id!: string;
    createdAt!: string;
    updatedAt!: string;
    subscriptionPlanId!: string;
    company!: Company;

    constructor(data: SubscriptionPlanCompany){
        Object.assign(this, data);
        this.company = new Company(data.company);
    }
}